export function parsePageSize(size: string): [number, number] | null {
  const parts = size.trim().split(/x/i).map(Number);
  if (
    parts.length !== 2 ||
    !Number.isFinite(parts[0]) ||
    !Number.isFinite(parts[1])
  ) {
    return null;
  }
  // Input is H×W; return [width, height] for callers
  return [parts[1], parts[0]];
}

export function splitPageSizes(pages: { size: string }[]): [number, number][] {
  return pages.map((page) => {
    const parsed = parsePageSize(page.size);
    if (!parsed) {
      throw new Error(
        `Invalid page size: "${page.size}". Use H×W format (e.g. 11×8.5).`,
      );
    }
    return parsed;
  });
}

export function getMailerDimensionsFromPageSizes(
  pageSizes: number[][],
): string | null {
  if (pageSizes.length === 0) return null;
  const [width, height] = pageSizes[0];
  return `${height}x${width}`;
}

export function getMailerDimensionsFromPages(
  pages: { frameWidth: number; frameHeight: number }[],
): string | null {
  if (pages.length === 0) return null;
  const first = pages[0];
  return `${first.frameHeight}x${first.frameWidth}`;
}
